import React, { useState } from "react";

export const Theme = React.createContext(null);
export const ThemeContext = props => {
    let storedTheme = "light";
    //let storedTheme = JSON.parse(localStorage.getItem("theme"));
    //if (storedTheme == null) {
    //    localStorage.setItem("theme", JSON.stringify("light"));
    //    storedTheme = "light";
    //} 

    const [theme, setTheme] = useState(storedTheme);
    const contextValue = {
        theme, setTheme
    };
    return (
        <>
            <Theme.Provider value={contextValue}>{props.children}</Theme.Provider>
        </>
    );
}
